export enum PlotReasonFilter {
    All = -1,
    Other,
    Ignition,
    FMS,
    Telematics,
    Travel,
    Accelerometer,
    Temperature
}
